// NotFound.jsx - página de error 404 profesional con auto-redirect
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';
import Navbar from '../components/Navbar';
import SEOHead from '../components/SEOHead';

function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirect a home después de 10 segundos
    const timer = setTimeout(() => {
      navigate('/');
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>
      <SEOHead 
        title="Página No Encontrada - Edutech Pulse Lab"
        description="La página que buscas no existe"
        robots="noindex, nofollow"
      />
      <Navbar />
      
      <div className="min-h-[calc(100vh-var(--header-height-mobile))] md:min-h-[calc(100vh-var(--header-height-desktop))] bg-gradient-to-b from-gray-50 via-white to-gray-50 flex items-center justify-center px-4 pt-[112px] md:pt-[164px]">
        <div className="max-w-2xl w-full text-center">
          {/* Ilustración 404 */}
          <div className="mb-8 relative">
            <div className="text-[180px] md:text-[240px] font-black text-gray-100 leading-none select-none">
              404
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <Search className="w-20 h-20 md:w-24 md:h-24 text-gray-300 animate-pulse" />
            </div>
          </div>

          {/* Mensaje */}
          <h1 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4">
            Página no encontrada
          </h1>
          <p className="text-base md:text-lg text-gray-600 mb-8 max-w-md mx-auto">
            La página que buscas no existe o fue movida. 
            Serás redirigido al inicio en <span className="font-semibold text-cyan-600">10 segundos</span>.
          </p>

          {/* Botones de acción */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0c203b] to-blue-700 text-white px-8 py-4 rounded-xl font-semibold text-base shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              <Home className="w-5 h-5" />
              Ir al Inicio
            </Link>
            
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-2 border-2 border-gray-300 text-gray-700 px-8 py-4 rounded-xl font-semibold text-base hover:border-gray-400 hover:bg-gray-50 transition-all duration-300"
            >
              <ArrowLeft className="w-5 h-5" />
              Volver Atrás
            </button>
          </div>

          {/* Enlaces útiles */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500 mb-4">¿Buscabas alguna de estas páginas?</p>
            <div className="flex flex-wrap gap-3 justify-center">
              <Link to="/programas" className="text-sm text-cyan-600 hover:text-cyan-700 hover:underline">
                Programas Ejecutivos
              </Link>
              <span className="text-gray-300">•</span>
              <Link to="/login" className="text-sm text-cyan-600 hover:text-cyan-700 hover:underline">
                Iniciar Sesión
              </Link>
              <span className="text-gray-300">•</span>
              <Link to="/recursos" className="text-sm text-cyan-600 hover:text-cyan-700 hover:underline">
                Recursos
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NotFound;
